module.exports = __webpack_public_path__ + "static/media/Screenshot_7-thumb.f52b3166.png";